import { render, staticRenderFns } from "./RewardDialog.vue?vue&type=template&id=4aa3d195&scoped=true&"
import script from "./RewardDialog.vue?vue&type=script&lang=js&"
export * from "./RewardDialog.vue?vue&type=script&lang=js&"
import style0 from "./RewardDialog.vue?vue&type=style&index=0&id=4aa3d195&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa3d195",
  null
  
)

component.options.__file = "RewardDialog.vue"
export default component.exports